import Vue from 'vue';
import Vuex from 'vuex';

import { accountStore } from '@/shared/config/store/account-store';
import { alertStore } from '@/shared/config/store/alert-store';
import { translationStore } from '@/shared/config/store/translation-store';
import { axiosRequestsStore } from '@/shared/config/store/axios-requests-store';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accountStore,
    alertStore,
    translationStore,
    axiosRequestsStore
  }
});
